import type { ViewMode } from "./ViewToggle";

type Props = {
  view?: ViewMode;
};

export function SkeletonCard({ view = "grid" }: Props) {
  if (view === "compact") {
    return (
      <div className="card card-compact card-skeleton" aria-hidden>
        <span className="skel-block skel-icon" />
        <span className="skel-block skel-line skel-w-30" />
        <span className="skel-block skel-line skel-w-15" />
        <span className="skel-block skel-line skel-w-20" />
        <span className="skel-block skel-pill" />
      </div>
    );
  }
  return (
    <div className="card card-skeleton" aria-hidden>
      <div className="card-head">
        <div className="card-title-row">
          <span className="skel-block skel-icon" />
          <span className="skel-block skel-line skel-w-70" />
        </div>
        <span className="skel-block skel-line skel-w-90" />
        <span className="skel-block skel-line skel-w-60" />
      </div>
      <div className="card-foot">
        <span className="skel-block skel-pill" />
        <span className="skel-block skel-pill" />
      </div>
    </div>
  );
}

export function SkeletonGrid({
  count = 6,
  view = "grid",
}: {
  count?: number;
  view?: ViewMode;
}) {
  return (
    <div className={`card-grid${view === "compact" ? " card-grid-compact" : ""}`}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} view={view} />
      ))}
    </div>
  );
}
